import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  makeStyles,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import apiHelper from "../../../util/ApiHelper";
import _ from "lodash";
import { useLoading } from "../../../util/LoadingProvider";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build";
import editorConfiguration from "../../../util/EditorConfiguration";
import Autocomplete from "@material-ui/lab/Autocomplete";
import UploadImage from "../UploadImage";
import ScreeningSections from "./ScreeningSections";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import MainDirectorSelectedFilmographySections from "./MainDirectorSelectedFilmography";
import DirectorSection from "./DirectorSection";
import CreditSections from "./Credits";
import BannerSections from "./Banner";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import OtherSelectedFilmographySections from "./OtherSelectedFilmography";
import { formatDatetime } from "../../../util";
import { toast } from "react-toastify";

const schema = yup.object().shape({
  filmScreenings: yup.array().of(
    yup.object().shape({
      venue: yup.string().required("Required"),
    })
  ),
});

const useStyles = makeStyles((theme) => ({
  box: {
    padding: 0,
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      fontSize: "13px",
      textTransform: "inherit",
      color: "#306F9D",
    },
  },
  innerBox: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
    background: "#ffffff",
  },
  input: {
    width: "100%",
    marginTop: "20px",
    marginLeft: "10px",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const defaultFormValues = {
  id: 0,
  sequence: 0,
  originalName: "",
  code: "",
  categories: [],
  subcategories: [],
  isAudience: "ACTIVE",
  status: 1,
  filmIcons: [],
  filmTabs: [],
  yearsOfPresentation: "",
  runtime: 0,
  format: "",
  level: 0,
  chineseSubtitle: "",
  highlight:false,
  directorImage: "",
  relevantFilms: [],
  filmPrevues: [],
  filmScreenings: [],
  localizations: {
    en: {
      title: "",
      subtitle: "",
      image: "",
      director: "",
      cast: "",
      languages: "",
      color: "",
      country: "",
      description: "",
      pdf: "",
      pdfName: "",
      directorStatement: "",
      sponsor: "",
      directors: {
        directors: [
          {
            desc: "",
            img: "",
            filmography: [],
          },
        ],
      },
      credit: {credit:[]},
      masterClass: "",
      trailer: "",
      more: "",
      directorInterview: "",
      productionNote: "",
    },
    tc: {
      title: "",
      subtitle: "",
      image: "",
      director: "",
      cast: "",
      languages: "",
      color: "",
      country: "",
      description: "",
      pdf: "",
      pdfName: "",
      directorStatement: "",
      sponsor: "",
      directors: {
        directors: [
          {
            desc: "",
            img: "",
            filmography: [],
          },
        ],
      },
      credit: {credit:[]},
      masterClass: "",
      trailer: "",
      more: "",
      directorInterview: "",
      productionNote: "",
    },
  },
};

export default function FilmDetailPage({ disabled, ...props }) {
  const { match } = props;
  const history = useHistory();
  const classes = useStyles();
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const { setLoading } = useLoading();
  const [activeTab, setActiveTab] = React.useState(0);
  const [formError, setFormError] = React.useState({});
  const [filmList, setFilmList] = React.useState([]);
  const [filmTagList, setFilmTagList] = React.useState([]);
  const [filmIconList, setFilmIconList] = React.useState([]);
  const [venueList, setVenueList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [originalSubCategoryList, setOriginalSubCategoryList] = React.useState(
    []
  );
  const [subCategoryList, setSubCategoryList] = React.useState([]);
  const [selectedCats, setSelectedCats] = React.useState([]);
  const [seq, setSeq] = React.useState(0);

  const { control, handleSubmit, getValues, setValue, reset, formState } =
    useForm({
      defaultValues,
      resolver: yupResolver(schema),
    });

  const relevantFilms = useWatch({
    control,
    name: "relevantFilms",
  });

  const filmTag = useWatch({
    control,
    name: "filmTabs",
  });

  const filmIcons = useWatch({
    control,
    name: "filmIcons",
  });

  const categories = useWatch({
    control,
    name: "categories",
  });

  const subcategories = useWatch({
    control,
    name: "subcategories",
  });

  const replaceNullOrFormat = (target, source, key, needFormating) => {
    if (!_.get(target, key)) {
      const defaultData = _.cloneDeep(_.get(source, key));
      _.set(target, key, defaultData);
    } else if (needFormating) {
      try {
        const unformatted = _.cloneDeep(_.get(target, key));
        const formatted = JSON.parse(unformatted);
        _.set(target, key, formatted);
      } catch (e) {
        console.log("JSON parse error:", e);
      }
    }
  };

  const formatFilmScreeningVenue = (data) => {
    for (let i = 0; i < data.filmScreenings.length; i++) {
      data.filmScreenings[i].venue =
        data.filmScreenings[i].venue?.id !== null
          ? data.filmScreenings[i].venue.id
          : null;
    }
  };

  const formatReq = (req) => {
    const creditEn = req.localizations.en.credit;
    const creditTc = req.localizations.tc.credit;
    const screenings = req.filmScreenings;
    const prevues = req.filmPrevues;
    
    if (Array.isArray(creditEn?.credit)) {
      for (let i = 0; i < creditEn.credit.length; i++) {
        creditEn.credit[i] = _.omit(creditEn.credit[i], "id");
      }
    }
    if (Array.isArray(creditTc?.credit)) {
      for (let i = 0; i < creditTc.credit.length; i++) {
        creditTc.credit[i] = _.omit(creditTc.credit[i], "id");
      }
    }
    req.localizations.en.credit = JSON.stringify(creditEn || { credit: [] });
    req.localizations.tc.credit = JSON.stringify(creditTc || { credit: [] });
    req.localizations.tc.image = req.localizations.en.image;
    req.filmScreenings = screenings ? screenings : [];

    if(req.filmScreenings.length !== 0) {
      req.filmScreenings.map(function(fs) {
        // console.log("fs.programmeUpdates");
        // console.log(fs.programmeUpdates);
        // var pu = [];
        // if(fs.programmeUpdates.length !== 0) {
        //   pu = fs.programmeUpdates.map(({ id }) => id)
        // }
        // console.log("pu");
        // console.log(pu);
        // fs.programmeUpdates = pu;
        if (fs.startDatetime) {
          fs.startDatetime = formatDatetime(
            fs.startDatetime,
            "YYYY-MM-DDTHH:mm:ss"
          );
        }
        if (fs.endDatetime) {
          fs.endDatetime = formatDatetime(
            fs.endDatetime,
            "YYYY-MM-DDTHH:mm:ss"
          );
        }
      })
    }

    req.filmPrevues = prevues ? prevues : [];
    if (req.filmPrevues.length !== 0) {
      req.filmPrevues = req.filmPrevues.map(function (fp) {
        console.log("en image");
        console.log(fp.localizations.en.image);
        fp.localizations.tc.image = fp.localizations.en.image;
        return fp;
      });
    }

    var isDirectorEmpty = true;

    const iterate = (obj) => {
      Object.keys(obj).forEach((key) => {
        console.log(`key: ${key}, value: ${obj[key]}`);

        if (typeof obj[key] === "object" && obj[key] !== null) {
          iterate(obj[key]);
        } else {
          if (key != "id" && obj[key]) {
            isDirectorEmpty = false;
          }
        }
      });
    };

    iterate(req.localizations.en.directors);

    console.log("isDirectorEmpty");
    console.log(isDirectorEmpty);

    if (isDirectorEmpty) {
      req.localizations.en.directors = "";
      req.localizations.tc.directors = "";
    } else {
      //remove obsolete format
      if (req.localizations.en.directors.main) {
        delete req.localizations.en.directors.main;
      }

      if (req.localizations.tc.directors.main) {
        delete req.localizations.tc.directors.main;
      }

      //clone director img to tc
      req.localizations.en.directors?.directors?.map((director, index) => {
        if (director.img) {
          req.localizations.tc.directors.directors[index].img = director.img;
          // en image is removed, but kept in tc
        } else if (!director.img && req.localizations.tc.directors.directors[index].img) {
          req.localizations.tc.directors.directors[index].img = ""
        }
        return director;
      })

      req.localizations.en.directors = JSON.stringify(
        req.localizations.en.directors
      );
      req.localizations.tc.directors = JSON.stringify(
        req.localizations.tc.directors
      );
    }
  };

  const getAllFilm = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getFilmListing({
        page: 0,
        pageSize: 999999,
      });
      const resultList = result.data.content.map((item) => ({
        label: item.localizations.en.title,
        id: item.id,
      }));
      setFilmList(resultList);
      setSeq(result.data.content[0].sequence + 1);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllFilmTags = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getFilmTags({
        pageSize: 99999999,
      });
      const resultList = result.data.content.map((item) => ({
        label: item.localizations.en.name,
        id: item.id,
      }));
      setFilmTagList(resultList);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getFilmIconNameList = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getFilmIconNameList();
      const resultList = result.data.map((item) => ({
        label: item.localizations.en.title,
        id: item.id,
      }));
      setFilmIconList(resultList);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getAllVenues = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getHkiffVenue({
        pageSize: 99999999,
      });
      const resultList = result.data.content.map((item) => ({
        label: item.localizations.en.name,
        id: item.id,
      }));
      setVenueList(resultList);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getCategories = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getFilmCategories(
        null,
        0,
        0,
        9999999,
        ""
      );
      console.log("getCategorySelection: ", result);
      setCategoryList(
        result.data.content.map((category) => ({
          id: category.id,
          label: category.localizations.en.name,
        }))
      );
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getSubCategories = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getFilmSubCategories(
        null,
        "en",
        0,
        0,
        9999999,
        ""
      );
      console.log("getFilmSubCategories: ", result);
      const filteredList = result.data.content.map((subcategory) => ({
        id: subcategory.id,
        label: subcategory.localizations.en.name,
        categoryId: subcategory.categoryId,
      }));
      setOriginalSubCategoryList(filteredList);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getFilmById = React.useCallback(
    async (id) => {
      try {
        setLoading(true);
        // TODO
        const result = await apiHelper.hkiff.getFilmById(id);
        console.log("data");
        console.log(result);
        let resultData = result.data;
        replaceNullOrFormat(resultData, defaultFormValues, "filmScreenings");
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.description"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.credit",
          true
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.masterClass"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.trailer"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.more"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.directorStatement"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.directorInterview"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.productionNote"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.description"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.credit",
          true
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.masterClass"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.trailer"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.more"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.directorInterview"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.productionNote"
        );
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.directorStatement"
        );
        if (Array.isArray(resultData.filmTabs)) {
          resultData.filmTabs = resultData.filmTabs.map((item) => item.tab.id);
        }
        if (Array.isArray(resultData.filmIcons)) {
          resultData.filmIcons = resultData.filmIcons.map(
            (item) => item.filmIcon.id
          );
        }
        if (parseInt(resultData.level) !== 3) {
          resultData.level = 0;
        }
        formatFilmScreeningVenue(resultData);

        // directors EN is saved as json string 
        if (resultData.localizations.en.directors != "") {
          resultData.localizations.en.directors = JSON.parse(
            resultData.localizations.en.directors
          );
        }
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.en.directors",
        );
        //fix if directors.directors is [] empty array, ckeditor in Director block error because of null value
        if (resultData.localizations.en.directors.directors.length == 0) {
          resultData.localizations.en.directors =
            defaultFormValues.localizations.en.directors;
        }

        // directors TC is saved as json string 
        if (resultData.localizations.tc.directors != "") {
          resultData.localizations.tc.directors = JSON.parse(
            resultData.localizations.tc.directors
          );
        }
        replaceNullOrFormat(
          resultData,
          defaultFormValues,
          "localizations.tc.directors",
        );
        //fix if directors.directors is [] empty array, ckeditor in Director block error because of null value
        if (resultData.localizations.tc.directors.directors.length == 0) {
          resultData.localizations.tc.directors =
            defaultFormValues.localizations.tc.directors;
        }

        setSelectedCats(resultData.categories);
        setDefaultValues(resultData);
        reset(resultData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const onSubmit = async (value) => {
    // for editing
    if (match.params.id !== "new") {
      try {
        setLoading(true);
        console.log(value);
        const req = { ...value };
        formatReq(req);
        console.log(req);
        const result = await apiHelper.hkiff.updateFilmById(
          match.params.id,
          req
        );
        if (result.data.id) {
          toast.dark("Your changes are saved.");
          getFilmById(result.data.id);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
    // for creating
    else {
      try {
        setLoading(true);
        console.log("creating seq", seq);
        const req = { ...value, sequence: seq };
        formatReq(req);
        console.log('request',req);
        const result = await apiHelper.hkiff.createFilm(req);
        if (result.data.id) {
          toast.dark("Your changes are saved.");
          history.push(`/hkiff/film/${result.data.id}`);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "filmScreenings", // unique name for your Field Array
    // keyName: "id", default to "id", you can change the key name
  });

  React.useEffect(() => {
    console.log(formError);
    if (!_.isEqual(formError, formState.errors)) {
      setFormError(formState.errors);
      // TODO
      // if (formState.errors?.localizations?.en) {
      //   setActiveTab(0);
      //   return;
      // }
      // if (formState.errors?.localizations?.tc) {
      //   setActiveTab(1);
      //   return;
      // }
    }
  }, [formState, formError]);

  React.useEffect(() => {
    getAllFilm();
  }, []);

  React.useEffect(() => {
    getAllFilmTags();
  }, []);

  React.useEffect(() => {
    getFilmIconNameList();
  }, []);

  React.useEffect(() => {
    getAllVenues();
  }, []);

  React.useEffect(() => {
    getCategories();
  }, []);

  React.useEffect(() => {
    getSubCategories();
  }, []);

  // display subCategoryList according to selected category
  React.useEffect(() => {
    // console.log({ selectedCats, originalSubCategoryList });
    var newSubCategoryList = originalSubCategoryList.filter((o) =>
      selectedCats?.includes(o.categoryId)
    );
    setSubCategoryList(newSubCategoryList);
  }, [selectedCats]);

  React.useEffect(() => {
    if (match.params.id !== "new") {
      getFilmById(match.params.id);
    }
  }, [match, getFilmById]);

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Film > {match.params.id !== "new" ? "Edit Film" : "Create Film"}
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{
          style: {
            top: "0",
            background: "#306F9D",
          },
        }}
      >
        <Tab label="Film Information" {...a11yProps(0)} />
        <Tab label="Additional Information" {...a11yProps(1)} />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={activeTab} index={0}>
            {/*1st Tab -- 1st Block*/}
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} ml={2} width="100%">
                <Typography variant="p">Film General Info</Typography>
              </Box>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.title"
                    rules={{ required: "Required" }}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title (English)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.title"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title (Traditional Chinese)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="originalName"
                    rules={{ required: "Required" }}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Original Name"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.subtitle"
                    rules={{ required: "Required" }}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Subtitle (English)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.subtitle"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Subtitle (Traditional Chinese)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>

                <Grid container item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mt={2}
                    mb={2}
                    ml={2}
                    width="100%"
                  >
                    <Typography variant="p">Categories</Typography>
                  </Box>

                  <Controller
                    defaultValue={[]}
                    name="categories"
                    control={control}
                    render={({
                      field: { onChange, value, ...rest },
                      fieldState: { error },
                    }) => {
                      return (
                        <Autocomplete
                          multiple
                          fullWidth
                          label="Categories"
                          options={categoryList}
                          disabled={disabled}
                          getOptionSelected={(option, value) =>
                            option.id === value.id
                          }
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Categories"
                              margin="dense"
                              placeholder="Categories"
                              error={!!error}
                              helperText={error ? error.message : ""}
                            />
                          )}
                          value={categoryList.filter((o) =>
                            categories?.includes(o.id)
                          )}
                          onChange={(e, values) => {
                            var selectedCats = values.map((item) => item.id);
                            setValue(`categories`, selectedCats);
                            setSelectedCats(selectedCats);
                          }}
                          {...rest}
                        />
                      );
                    }}
                  />
                </Grid>

                <Grid container item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mt={2}
                    mb={2}
                    ml={2}
                    width="100%"
                  >
                    <Typography variant="p">Subcategories</Typography>
                  </Box>

                  <Controller
                    defaultValue={[]}
                    name="subcategories"
                    control={control}
                    render={({
                      field: { onChange, value, ...rest },
                      fieldState: { error },
                    }) => {
                      return (
                        <Autocomplete
                          multiple
                          fullWidth
                          label="Subcategories"
                          options={subCategoryList}
                          disabled={disabled}
                          getOptionSelected={(option, value) =>
                            option.id === value.id
                          }
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Subcategories"
                              margin="dense"
                              placeholder="Subcategories"
                              error={!!error}
                              helperText={error ? error.message : ""}
                            />
                          )}
                          value={subCategoryList.filter((o) =>
                            subcategories?.includes(o.id)
                          )}
                          onChange={(e, values) => {
                            setValue(
                              `subcategories`,
                              values.map((item) => item.id)
                            );
                          }}
                          {...rest}
                        />
                      );
                    }}
                  />
                </Grid>

                <Grid container item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mt={2}
                    mb={2}
                    ml={2}
                    width="100%"
                  >
                    <Typography variant="p">Film Icon</Typography>
                  </Box>

                  <Controller
                    defaultValue={[]}
                    name="filmIcons"
                    control={control}
                    render={({
                      field: { onChange, value, ...rest },
                      fieldState: { error },
                    }) => {
                      return (
                        <Autocomplete
                          multiple
                          fullWidth
                          label="Film Icon"
                          options={filmIconList}
                          disabled={disabled}
                          getOptionSelected={(option, value) =>
                            option.id === value.id
                          }
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Film Icon"
                              margin="dense"
                              placeholder="Film Icon"
                              error={!!error}
                              helperText={error ? error.message : ""}
                            />
                          )}
                          value={filmIconList.filter((o) =>
                            filmIcons?.includes(o.id)
                          )}
                          onChange={(e, values) => {
                            setValue(
                              `filmIcons`,
                              values.map((item) => item.id)
                            );
                          }}
                          {...rest}
                        />
                      );
                    }}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mt={2}
                    mb={2}
                    ml={2}
                    width="100%"
                  >
                    <Typography variant="p">Tag</Typography>
                  </Box>
                  <Controller
                    defaultValue={[]}
                    name="filmTabs"
                    control={control}
                    render={({
                      field: { onChange, value, ...rest },
                      fieldState: { error },
                    }) => {
                      return (
                        <Autocomplete
                          multiple
                          fullWidth
                          label="Tag"
                          options={filmTagList}
                          disabled={disabled}
                          getOptionSelected={(option, value) =>
                            option.id === value.id
                          }
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Tag"
                              margin="dense"
                              placeholder="Tag"
                              error={!!error}
                              helperText={error ? error.message : ""}
                            />
                          )}
                          value={filmTagList.filter((o) =>
                            filmTag?.includes(o.id)
                          )}
                          onChange={(e, values) => {
                            setValue(
                              "filmTabs",
                              values.map((item) => item.id)
                            );
                          }}
                          {...rest}
                        />
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="code"
                    rules={{ required: "Required" }}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Code"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Grid container item xs={6}>
                    <Controller
                      defaultValues={defaultValues.yearsOfPresentation}
                      name="yearsOfPresentation"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="Year of Presentation"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <Controller
                      name="chineseSubtitle"
                      control={control}
                      render={({
                        field: { value, onChange, ...rest },
                        fieldState: { error },
                      }) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={{ marginLeft: "4px" }}
                                type="checkbox"
                                color="primary"
                                checked={value === "Yes"}
                                {...rest}
                                onChange={(event) => {
                                  setValue(
                                    "chineseSubtitle",
                                    event.target.checked ? "Yes" : "No"
                                  );
                                }}
                              />
                            }
                            label="This movie is screening with Chinese subtitle"
                          />
                        );
                      }}
                    />
                    <FormHelperText>
                      The result of this checkbox will appear only in the
                      chinese translation of this movie with this wording:
                      "中文字幕"
                    </FormHelperText>
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name="highlight"
                      control={control}
                      render={({
                        field: { value, onChange, ...rest },
                        fieldState: { error },
                      }) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={{ marginLeft: "4px" }}
                                type="checkbox"
                                color="primary"
                                checked={value === true}
                                {...rest}
                                onChange={(event) => {
                                  setValue(
                                    "highlight",
                                    event.target.checked ? true : false
                                  );
                                  if (!event.target.checked) {
                                    setValue("sequence", 0);
                                  }
                                }}
                              />
                            }
                            label="highlight this movie"
                          />
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      defaultValue={defaultValues.sequence}
                      name="sequence"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Sequece of highlight"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      defaultValue={defaultValues.runtime}
                      name="runtime"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Runtime"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      defaultValue={defaultValues.format}
                      name="format"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Format"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container item xs={6} alignItems="center">
                  <FormControl
                    fullWidth
                    variant="outlined"
                    style={{ marginLeft: "4px" }}
                  >
                    <InputLabel id="level-selection">Level</InputLabel>
                    <Controller
                      name={`level`}
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <Select
                          labelId="level-selection-label"
                          id="level-selection"
                          label="Level"
                          className={classes.select}
                          {...field}
                        >
                          <MenuItem value={0}>
                            <em>I</em>
                          </MenuItem>
                          <MenuItem value={3}>
                            <em>III</em>
                          </MenuItem>
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <UploadImage
                      name={`localizations.en.image`}
                      // data={data}
                      data={{
                        localizations: { en: { image: null } },
                      }}
                      embeddedName="localizations.en.image"
                      control={control}
                      Controller={Controller}
                      setValue={setValue}
                      getValues={getValues}
                      disabled={disabled}
                      uploadLabel="Upload Thumbnail Image"
                      changeLabel="Change Thumbnail Image"
                      uploadFolder="FILM"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            {/*1st Tab -- 2nd Block*/}
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.en.director"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Director (English)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "If more than 1 director, please seperated with ,"
                          }
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.tc.director"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Director (Traditional Chinese)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "If more than 1 director, please seperated with ,"
                          }
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.en.cast"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Cast (English)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "If more than 1 cast, please seperated with ,"
                          }
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.tc.cast"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Cast (Traditional Chinese)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "If more than 1 cast, please seperated with ,"
                          }
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.en.languages"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Languages (English)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "If more than 1 language, please seperated with ,"
                          }
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.tc.languages"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Languages (Traditional Chinese)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "If more than 1 language, please seperated with ,"
                          }
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.en.color"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Color (English)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.tc.color"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Color (Traditional Chinese)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.en.country"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Country (English)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.tc.country"
                      control={control}
                      render={({
                        field: { value, ...rest },
                        fieldState: { error },
                      }) => (
                        <TextField
                          label="Country (Traditional Chinese)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          value={value}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">Description (English)</Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.description"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Description (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.description"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                {/* <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <UploadImage
                      name="pdf"
                      lang="en"
                      // data={data}
                      data={{
                        localizations: { en: { pdf: null } },
                      }}
                      control={control}
                      Controller={Controller}
                      setValue={setValue}
                      getValues={getValues}
                      disabled={disabled}
                      uploadLabel="Upload PDF (English)"
                      changeLabel="Change PDF (English)"
                      uploadFolder="FILM"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.en.pdfName"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="PDF Name (English)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <UploadImage
                      name="pdf"
                      lang="tc"
                      // data={data}
                      data={{
                        localizations: { tc: { pdf: "" } },
                      }}
                      control={control}
                      Controller={Controller}
                      setValue={setValue}
                      getValues={getValues}
                      disabled={disabled}
                      uploadLabel="Upload PDF (Traditional Chinese)"
                      changeLabel="Change PDF (Traditional Chinese)"
                      uploadFolder="FILM"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="localizations.tc.pdfName"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="PDF Name (Traditional Chinese)"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid> */}
              </Grid>

              <Box fontWeight={900} fontSize={13} mt={2} ml={2} width="100%">
                <Typography variant="p">Status</Typography>
              </Box>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={4}>
                  <Controller
                    control={control}
                    name="status"
                    render={({
                      field: { value, onChange, ...rest },
                      fieldState: { error },
                    }) => (
                      <ToggleButtonGroup
                        {...rest}
                        value={value}
                        onChange={(event, newFormats) => {
                          if (newFormats !== null) {
                            onChange(newFormats);
                          }
                        }}
                        exclusive
                        aria-label="Status"
                        className={classes.input}
                      >
                        <ToggleButton
                          value={1}
                          aria-label="Active"
                          style={{ width: "50%" }}
                        >
                          Active
                        </ToggleButton>
                        <ToggleButton
                          value={0}
                          aria-label="Inactive"
                          style={{ width: "50%" }}
                        >
                          Inactive
                        </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  />
                </Grid>
              </Grid>

              <Box fontWeight={900} fontSize={13} mt={3} ml={2} width="100%">
                <Typography variant="p">is Audience</Typography>
              </Box>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={4}>
                  <Controller
                    control={control}
                    name="isAudience"
                    render={({
                      field: { value, onChange, ...rest },
                      fieldState: { error },
                    }) => (
                      <ToggleButtonGroup
                        {...rest}
                        value={value}
                        onChange={(event, newFormats) => {
                          if (newFormats !== null) {
                            onChange(newFormats);
                          }
                        }}
                        exclusive
                        aria-label="Status"
                        className={classes.input}
                      >
                        <ToggleButton
                          value={"ACTIVE"}
                          aria-label="Active"
                          style={{ width: "50%" }}
                          disabled={true}
                        >
                          Active
                        </ToggleButton>
                        <ToggleButton
                          value={"INACTIVE"}
                          aria-label="Inactive"
                          style={{ width: "50%" }}
                          disabled={true}
                        >
                          Inactive
                        </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  />
                </Grid>

                <Grid container item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mt={2}
                    mb={2}
                    ml={2}
                    width="100%"
                  >
                    <Typography variant="p">Relevant Films</Typography>
                  </Box>

                  <Controller
                    defaultValue={[]}
                    name="relevantFilms"
                    control={control}
                    render={({
                      field: { onChange, value, ...rest },
                      fieldState: { error },
                    }) => {
                      return (
                        <Autocomplete
                          multiple
                          fullWidth
                          label="Relevant Films"
                          options={filmList}
                          disabled={disabled}
                          getOptionSelected={(option, value) =>
                            option.id === value.id
                          }
                          getOptionLabel={(option) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Relevant Films"
                              margin="dense"
                              placeholder="Relevant Films"
                              error={!!error}
                              helperText={error ? error.message : ""}
                            />
                          )}
                          value={filmList.filter((o) =>
                            relevantFilms?.includes(o.id)
                          )}
                          onChange={(e, values) => {
                            console.log("ONCHANGE VALUES RESULT", values);
                            // onChange(values);
                            setValue(
                              "relevantFilms",
                              values.map((item) => item.id)
                            );
                          }}
                          {...rest}
                        />
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/*1st Tab -- 3rd Block*/}
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>
                <Box
                  fontWeight={900}
                  fontSize={13}
                  mt={2}
                  mb={1}
                  ml={2}
                  width="100%"
                >
                  <Typography variant="p">Banner Info</Typography>
                </Box>
                <Grid item xs={12}>
                  <BannerSections
                    getValues={getValues}
                    setValue={setValue}
                    control={control}
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </Box>

            {/*1st Tab -- 4th Block*/}
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>
                <Box
                  fontWeight={900}
                  fontSize={13}
                  mt={2}
                  mb={1}
                  ml={2}
                  width="100%"
                >
                  <Typography variant="p">Screening Info</Typography>
                </Box>
                <Grid item xs={12}>
                  <ScreeningSections
                    setValue={setValue}
                    control={control}
                    venueList={venueList}
                    fields={fields}
                    remove={remove}
                    append={append}
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            {/*2nd Tab -- 1st Block*/}
            <DirectorSection
              control={control}
              getValues={getValues}
              setValue={setValue}
              disabled={disabled}
            />

            {
              // defaultValues.localizations.en.directors.directors.map(function(director, key){
              //     return(
              <>
                {/* {`localizations.en.directors.directors[${key}].img`} */}

                {/* <UploadImage
                                                    name={`localizations.en.directors.directors[${key}].img`}
                                                    // data={data}
                                                    data={{
                                                        directorImage: ''
                                                    }}
                                                    control={control}
                                                    Controller={Controller}
                                                    setValue={setValue}
                                                    getValues={getValues}
                                                    disabled={disabled}
                                                    uploadLabel="Upload Director Photo"
                                                    changeLabel="Change Director Photo"
                                                    uploadFolder="FILM"
                                                /> */}
                {/* Key: {key}
                                    <DirectorSection directorIndex={key}
                                                    control={control}
                                                    getValues={getValues}
                                                    setValue={setValue}
                                                    disabled={disabled}/>

                                                     */}
              </>

              // )
              // })
            }

            {/*2nd Tab -- 2nd Block*/}
            {/* <Box className={classes.innerBox}>
                                        <Grid container
                                            direction="vertical"
                                            spacing={3}>
                                            <Box fontWeight={900}
                                                fontSize={13} mt={2}
                                                mb={1}
                                                ml={2} width="100%">
                                                <Typography variant="p">More
                                                    Directors</Typography>
                                            </Box>
                                            <Grid item xs={12}>
                                                <OtherSelectedFilmographySections
                                                    getValues={getValues}
                                                    setValue={setValue}
                                                    control={control}
                                                    disabled={disabled}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box> */}

            {/*2nd Tab -- 3rd Block*/}
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} ml={0} width="100%">
                <Typography variant="p">Director’s Statement</Typography>
              </Box>

              <Grid container direction="vertical" spacing={3}>
                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Director’s Statement (English)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.directorStatement"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Director’s Statement (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.directorStatement"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/*2nd Tab -- 4th Block*/}
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>
                <Box
                  fontWeight={900}
                  fontSize={13}
                  mt={2}
                  mb={1}
                  ml={2}
                  width="100%"
                >
                  <Typography variant="p">Credit</Typography>
                </Box>
                <Grid item xs={12}>
                  <CreditSections
                    getValues={getValues}
                    setValue={setValue}
                    control={control}
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </Box>

            {/*2nd Tab -- 5th Block*/}
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} width="100%">
                <Typography variant="p">Master Class</Typography>
              </Box>

              <Grid container direction="vertical" spacing={3}>
                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">Description (English)</Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.masterClass"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Description (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.masterClass"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/*2nd Tab -- 6th Block*/}
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} width="100%">
                <Typography variant="p">Trailer</Typography>
              </Box>

              <Grid container direction="vertical" spacing={3}>
                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">Description (English)</Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.trailer"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Description (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.trailer"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/*2nd Tab -- 7th Block*/}
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} width="100%">
                <Typography variant="p">Film Review</Typography>
              </Box>

              <Grid container direction="vertical" spacing={3}>
                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">Description (English)</Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.more"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Description (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.more"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} width="100%">
                <Typography variant="p">Director Interview</Typography>
              </Box>

              <Grid container direction="vertical" spacing={3}>
                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">Description (English)</Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.directorInterview"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Description (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.directorInterview"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.innerBox}>
              <Box fontWeight={900} fontSize={13} mb={3} width="100%">
                <Typography variant="p">Production Note</Typography>
              </Box>

              <Grid container direction="vertical" spacing={3}>
                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">Description (English)</Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.en.productionNote"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
                  <Typography variant="p">
                    Description (Traditional Chinese)
                  </Typography>
                </Box>

                <Grid item xs={12}>
                  <Controller
                    name="localizations.tc.productionNote"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                          console.log("Editor is ready to use!", editor);
                          // editor.setData(initialValues.terms.valueEn);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                          // console.log({ event, editor, data });
                        }}
                        onBlur={(event, editor) => {
                          console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          console.log("Focus.", editor);
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
          </TabPanel>

          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                style={{ marginRight: "20px" }}
                type="button"
                onClick={() => {}}
              >
                Preview
              </Button>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                Save Changes
              </Button>
              {match.params.id && (
                <Button
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#962013",
                    padding: "9px 16px",
                  }}
                  onClick={() => {}}
                >
                  Delete
                </Button>
              )}
            </div>
          )}
        </fieldset>
      </form>
    </div>
  );
}
